import { useNavigate } from "react-router-dom";

/* ================= BRAND COLORS ================= */
const COLORS = {
  primary: "#0D47A1",
  bgCream: "#FFF6EA",
  card: "#FFFFFF",
  border: "#E5E7EB",
  textDark: "#1E1E1E",
  textGrey: "#757575",
  success: "#16A34A",
};

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      
      {/* HEADER */}
      <div style={styles.pageHeader}>
        <h2 style={styles.title}>Sales Panel</h2>
        <span style={styles.subtitle}>
          Create and manage sales quickly
        </span>
      </div>

      {/* MAIN ACTION */}
      <div style={styles.centerBox}>
        <div
          style={styles.bigSaleCard}
          onClick={() => navigate("/sales")}
        >
          + Start New Sale
        </div>

      </div>
    </div>
  );
};

/* STYLES */

const styles = {
  page: {
    background: COLORS.bgCream,
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  pageHeader: {
    textAlign: "center",
    marginBottom: 30,
  },

  title: {
    fontWeight: 700,
    fontSize: 24,
    color: COLORS.textDark,
  },

  subtitle: {
    fontSize: 13,
    color: COLORS.textGrey,
  },

  centerBox: {
    display: "flex",
    flexDirection: "column",
    gap: 15,
    width: "100%",
    maxWidth: 300,
  },

  bigSaleCard: {
    background: COLORS.success,
    color: "#fff",
    padding: "18px",
    borderRadius: 12,
    fontSize: 18,
    fontWeight: 700,
    textAlign: "center",
    cursor: "pointer",
    boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
  },

  secondaryBtn: {
    background: COLORS.card,
    border: `1px solid ${COLORS.border}`,
    padding: "14px",
    borderRadius: 10,
    textAlign: "center",
    cursor: "pointer",
    fontWeight: 500,
  },
};

export default Dashboard;